module.exports = __webpack_public_path__ + "static/media/recovery_password_aside_owl.aed52125.svg";